import React from 'react';
import { motion } from 'framer-motion';
import './SectionNavigator.css';

interface SectionNavigatorProps {
  sections: string[];
  currentSection: number;
  onSectionClick: (index: number) => void;
  isScrolling: boolean;
}

const sectionNames = ['Hero', 'App', 'Testimonials'];

const SectionNavigator: React.FC<SectionNavigatorProps> = ({
  sections,
  currentSection,
  onSectionClick,
  isScrolling
}) => {
  return (
    <div className="section-navigator">
      <div className="nav-dots">
        {sections.map((_, index) => (
          <motion.button
            key={index}
            className={`nav-dot ${currentSection === index ? 'active' : ''}`}
            onClick={() => !isScrolling && onSectionClick(index)}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
            disabled={isScrolling}
            title={sectionNames[index]}
          >
            <span className="nav-dot-inner"></span>
            <span className="nav-dot-label">{sectionNames[index]}</span>
          </motion.button>
        ))}
      </div>
      
      <div className="scroll-progress">
        <div 
          className="progress-bar"
          style={{ 
            height: `${((currentSection + 1) / sections.length) * 100}%` 
          }}
        ></div>
      </div>
    </div>
  );
};

export default SectionNavigator;
